import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, ShoppingCart, X } from 'lucide-react';
import { useSiteData } from '../contexts/SiteDataContext';

const FloatingButtons = () => {
  const { books, author } = useSiteData();
  const bookData = books[0] || {};
  const authorData = author || {};
  const [showWhatsApp, setShowWhatsApp] = useState(false);
  const [showBuyMenu, setShowBuyMenu] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const buyLinks = [
    { name: 'Amazon', url: bookData.amazonLink, color: 'from-orange-400 to-orange-500' },
    { name: 'Flipkart', url: bookData.flipkartLink, color: 'from-blue-500 to-blue-600' },
    { name: 'Garuda Prakashan', url: bookData.garudaLink, color: 'from-green-500 to-green-600' },
  ];

  return (
    <>
      <AnimatePresence>
        {isVisible && (
          <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-4">
            {/* Buy Book Menu */}
            <AnimatePresence>
              {showBuyMenu && (
                <motion.div
                  initial={{ opacity: 0, y: 20, scale: 0.8 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: 20, scale: 0.8 }}
                  className="bg-white rounded-2xl shadow-2xl p-4 mb-2 border border-orange-200"
                >
                  <div className="flex items-center justify-between mb-3">
                    <h4 className="font-bold text-gray-900">Buy Book</h4>
                    <button
                      onClick={() => setShowBuyMenu(false)}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      <X className="h-4 w-4" />
                    </button>
                  </div>
                  <div className="space-y-2">
                    {buyLinks.map((link, index) => (
                      <motion.a
                        key={index}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className={`block px-4 py-2 bg-gradient-to-r ${link.color} text-white rounded-xl font-semibold text-sm hover:shadow-lg transition-all duration-300`}
                      >
                        {link.name}
                      </motion.a>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Buy Button */}
            <motion.button
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0 }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => setShowBuyMenu(!showBuyMenu)}
              className="w-16 h-16 bg-gradient-to-r from-orange-500 to-orange-600 rounded-full flex items-center justify-center shadow-2xl hover:shadow-orange-500/50 transition-all duration-300"
            >
              <ShoppingCart className="h-7 w-7 text-white" />
            </motion.button>

            {/* WhatsApp Button */}
            <motion.a
              href={`https://wa.me/${authorData.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0 }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="w-16 h-16 bg-gradient-to-r from-green-500 to-green-600 rounded-full flex items-center justify-center shadow-2xl hover:shadow-green-500/50 transition-all duration-300"
            >
              <MessageCircle className="h-7 w-7 text-white" />
            </motion.a>
          </div>
        )}
      </AnimatePresence>
    </>
  );
};

export default FloatingButtons;